import { ProjectsService } from "@/common/api.service";
import { FETCH_CALENDAR_PLAN } from "./actions.type";

const state = {
  calendarItems: {
    PLAN: [],
    YEAR_SETTING: {
      yearEnd: 0,
      yearStart: 0
    }
  }
};

const getters = {
  calendarItems() {
    return state.calendarItems;
  }
};

const actions = {
  [FETCH_CALENDAR_PLAN]({ state }, id) {
    ProjectsService.loadPlan(id)
      .then(({ data }) => {
        let years = [];
        for (
          let i = data.YEAR_SETTING.yearStart;
          i <= data.YEAR_SETTING.yearEnd;
          i++
        ) {
          years.push(i);
        }

        function pushYears(items) {
          if (items && items.length > 0) {
            items.forEach(function(item) {
              item.IS_HIDE = false;
              if (item.YEAR_DATA === null) {
                item.YEAR_DATA = [];
                years.forEach(function(v) {
                  item.YEAR_DATA.push({
                    UF_PLAN_ROW_ID: item.ID,
                    UF_KV1: 0,
                    UF_KV2: 0,
                    UF_KV3: 0,
                    UF_KV4: 0,
                    UF_YEAR: v
                  });
                }, this);
              }
              pushYears(item.CHILD);
            }, this);
          }
        }
        if (data.PLAN) {
          pushYears(data.PLAN);
        }
        state.calendarItems = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

export default {
  state,
  getters,
  actions
};
